<template>
  <success :show-promotes='showPromotes'>
    <thanks :email='email' :title='customTitle || title'>
      <template v-if='isNeedUnAssignUser'>
        <span slot='subtitle' v-html="$t('billing.success.downgrade_txt')" />
        <slot name='unassign'>
          <subtitle :sub-title='assignText' />
          <div>
            <user-management-cta :cta-name="userManagementCtaName" :utm-content='UTM_CONTENT_CODE.unassignUsers' />
            <view-account type='plain' />
          </div>
        </slot>
      </template>
      <template v-else-if='isDownsell'>
        <span slot='subtitle' v-html="$t('billing.success.downgrade_txt')" />
        <view-account />
      </template>
      <template v-else-if='isUpsell'>
        <slot name='upsell'>
          <subtitle :sub-title="$t('billing.success.confirmation.user_assign_desc')" />
          <user-management-cta :cta-name="$t('billing.success.confirmation.user_cta')"  :utm-content='UTM_CONTENT_CODE.assignLicenseToUsers'/>
        </slot>
      </template>
      <template v-else>
        <slot name="viewAccountOnly">
          <view-account />
        </slot>
      </template>
      <download-action v-if='isShowDownload' />
    </thanks>
  </success>
</template>

<script>
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template';
import DownloadAction from '@/views/succezz/thanks-template/download-action.vue';
import { mapGetters, mapState } from 'vuex';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import UserManagementCta from '@/views/succezz/thanks-template/user-management-cta.vue';
import { dateTimeFormat } from '@/utils/dateformat';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import { isBoolean } from 'lodash';
import common from '@/views/succezz/mixin/common';
import { flowTypes } from '@/common/service/page-config';
import { getApmFlowType, PLAN_TYPES } from '@/views/succezz/utils';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';
import { $config } from '@/global-install';
export default {
  name: "CommonAddon",
  props: {
    customTitle: String,
  },
  mixins: [common],
  components: {
    Subtitle,
    UserManagementCta,
    ViewAccount,
    DownloadAction,
    Success,
    Thanks,
  },
  data() {
    return {
      UTM_CONTENT_CODE
    }
  },
  computed: {
    ...mapGetters(['boughtPlans', 'getCurrentBasePlanInfo', 'successConfig', 'persistState']),
    ...mapState({
      currentEditPlan: (state) => state.ShoppingCart.currentEditPlan,
    }),
    isAPM() {
      return !!this.persistState.confirmationDetails?.isAPM;
    },
    isShowDownload() {
      // only for NN
      if (this.$context.is.buyNow || getApmFlowType() === flowTypes.buyNow) return true;
      return false;
    },
    currentUpdatedPlan() {
      if (this.currentEditPlan?.plan_code) {
        const plan = this.boughtPlans.find(p => p.plan_code === this.currentEditPlan?.plan_code);
        return plan || { cartInfo: {} };
      }
      return { cartInfo: {} };
    },
    currentSelectedPlan() {
      if (this.currentEditPlan?.plan_code) {
        const plan = this.getSelectedPlans.find(p => p.plan_code === this.currentEditPlan?.plan_code);
        return plan || { cartInfo: {} };
      }
      return { cartInfo: {} };
    },
    isNeedUnAssignUser() {
      if (this.unassignLicenses) {
        return true;
      }
      return false;
    },
    unassignLicenses() {
      const quantity = this.persistState.downgradeState?.unAssignLicenseQuantity;
      return quantity > 0 ? quantity : false;
    },
    billingDate() {
      return dateTimeFormat(this.persistState.downgradeState?.planExpireTime);
    },
    assignText() {
      return this.$t('billing.success.downgrade_unassign_licenses', [this.unassignLicenses, this.billingDate]);
    },
    isLicenseIncrease() {
      return (this.currentSelectedPlan?.cartInfo?.selected_number > this.currentEditPlan?.cartInfo?.selected_number);
    },
    isLicenseDecrease() {
      return (this.currentSelectedPlan?.cartInfo?.selected_number < this.currentEditPlan?.cartInfo?.selected_number);
    },
    noNeedCheckLicense() {
      if ($config('from') === PLAN_TYPES.VIDEO_MANAGEMENT || $config('from_sub') === PLAN_TYPES.VIDEO_MANAGEMENT) {
        return true;
      }
      return false;
    },
    isDownsell() {
      if (this.noNeedCheckLicense) return false;
      if (!this.$context.is.edit) return false;
      if (this.isNeedUnAssignUser) return true;
      if (this.isLicenseDecrease) return true;
      const { has_downgrade_request, has_decrease_request, has_same_pending_plan } = this.currentUpdatedPlan.cartInfo;
      return (has_downgrade_request || has_decrease_request || has_same_pending_plan);
    },
    isUpsell() {
      if (this.noNeedCheckLicense) return false;
      if (this.$context.is.add2cart) {
        const hasOneTimePlan = this.getSelectedPlans.find(p => p.billing_cycle === BILLING_CYCLE.ONE_TIME);
        if (hasOneTimePlan) return true;
        const originalBoughtPlanCodes = this.originalBoughtPlans.map(p => p.plan_code);
        const getSelectedPlanCodes = this.getSelectedPlans.filter(p => ![planTypes.CMR, planTypes.TOLLFREE, planTypes.ROOM_CONNECTOR].includes(p.type)).map(p => p.plan_code);
        // if selected plan codes doesn't exist in origianl bought plans, that means this is the fisrt time buy this plan
        if (getSelectedPlanCodes.find(code => !originalBoughtPlanCodes.includes(code))) {
          return true;
        }
        if (this.isLicenseIncrease) return true;
      }
      if (!this.$context.is.edit) return false;
      if (this.isLicenseIncrease) return true;
      return isBoolean(this.isDownsell) && !this.isDownsell;
    },
    showPromotes() {
      return false;
    },
    getSelectedPlans() {
      return this.persistState.confirmationDetails.getSelectedPlans;
    },
    originalBoughtPlans() {
      return this.persistState.confirmationDetails.boughtPlans;
    },
    userManagementCtaName() {
      return this.$t('billing.success.unassign_users');
    }
  },
};
</script>
